import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CookieWrapper } from '@services/cookie.service';
import { AppRoutes } from '@helpers/app-routes';
import { AuthCredentialsFormComponent } from '@components/auth-credentials-form/auth-credentials-form.component';
import { LoaderComponent } from '@components/app-loader/app-loader.component';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [RouterLink, TranslateModule, AuthCredentialsFormComponent, LoaderComponent],
  styleUrl: './login-page.component.scss',
  host: {
    class: 'flex-1 h-full block',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './login-page.component.html',
})
export class LoginPageComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly cookie = inject(CookieWrapper);

  ngOnInit(): void {
    if (this.cookie.check('caisse_token')) {
      void this.router.navigate([AppRoutes.scanPage]);
    }
  }

  onLoginSuccess(): void {
    void this.router.navigate([AppRoutes.scanPage]);
  }
}
